import React from 'react'
import { Box } from '@chakra-ui/react'
import NoteBox from './note-box'

const ProgressNote = ({
  progressNote,
  handleTrackEvent,
  isNext,
  staticHeight,
  showTranscript
}: any) => {
  const {
    id,
    note: v1Note,
    nextNote: v2Note,
    noteType,
    template
  } = progressNote

  const note = isNext ? v2Note : v1Note

  return (
    <Box>
      {template.sections.map((section: any) => (
        <NoteBox
          noteId={id}
          key={`${progressNote.id}-${section.key}`}
          type={noteType}
          field={section.key}
          isEditable={!isNext}
          buttonId={`pendo-copy-${noteType}-${section.key}-tag`}
          label={section.displayName}
          value={note[section.key] || ''}
          emptyMessage={`No ${section.key} note`}
          trackEvent={handleTrackEvent}
          isNext={isNext}
          staticHeight={staticHeight}
          showTranscript={showTranscript}
        />
      ))}
    </Box>
  )
}

export default ProgressNote
